// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerPartNumberItemStyles } from "@steiner/App/Components/CustomerPartNumbers/CustomerPartNumberItem";
import { customerPartNumberItemWithoutProductStyles } from "@steiner/App/Components/CustomerPartNumbers/CustomerPartNumberItemWithoutProduct";
import { css } from "styled-components";

customerPartNumberItemWithoutProductStyles.productDescriptionCell = {
    ...customerPartNumberItemStyles.productDescriptionCell,
};

customerPartNumberItemWithoutProductStyles.partNumberCell = {
    ...customerPartNumberItemStyles.partNumberCell,
};

customerPartNumberItemWithoutProductStyles.editCell = {
    ...customerPartNumberItemStyles.editCell,
};

customerPartNumberItemWithoutProductStyles.addToCartCell = {
    ...customerPartNumberItemStyles.addToCartCell,
};

customerPartNumberItemWithoutProductStyles.addToListCell = {
    ...customerPartNumberItemStyles.addToListCell,
};

customerPartNumberItemWithoutProductStyles.productDescriptionText = {
    ...customerPartNumberItemStyles.productDescriptionText,
};

customerPartNumberItemWithoutProductStyles.editLink = {
    ...customerPartNumberItemStyles.editLink,
};

customerPartNumberItemWithoutProductStyles.deleteLink = {
    ...customerPartNumberItemStyles.deleteLink,
};

customerPartNumberItemWithoutProductStyles.updatePartNumberButton = {
    ...customerPartNumberItemStyles.updatePartNumberButton,
};

customerPartNumberItemWithoutProductStyles.actionsContainer = {
    ...customerPartNumberItemStyles.actionsContainer,
};

customerPartNumberItemWithoutProductStyles.productDescriptionWrapper = {
    ...customerPartNumberItemStyles.productDescriptionWrapper,
};

customerPartNumberItemWithoutProductStyles.modalGridContainer = {
    ...customerPartNumberItemStyles.modalGridContainer,
};

customerPartNumberItemWithoutProductStyles.modalGridItem = {
    ...customerPartNumberItemStyles.modalGridItem,
};

customerPartNumberItemWithoutProductStyles.modalCancelButton = {
    ...customerPartNumberItemStyles.modalCancelButton,
};

customerPartNumberItemWithoutProductStyles.modalConfirmButton = {
    ...customerPartNumberItemStyles.modalConfirmButton,
}; 